module.exports = __webpack_public_path__ + "static/media/dth_1.207427c4.png";